// removed by extract-text-webpack-plugin
module.exports = {"header":"header__1HEd1"};


//////////////////
// WEBPACK FOOTER
// ./styles/plan/blockHeader.scss
// module id = 496
// module chunks = 68